import React from "react";

import "./styles.scss";

export default class CompanyInfo extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    const sealsFooter = this.props.seals;
    return (
      <div className="companyInfo">
        {sealsFooter && (
          <>
            <div className="infoLine">
              <a href="#" target="_blank">
                Términos y condiciones
              </a>{" "}
              de nuestras garantías y pruebas.⁠
            </div>
            <div className="infoLine">
              {" "}
              Llamá al +54 261 4439300. San Martín Sur 600.
            </div>
          </>
        )}
        {!sealsFooter && (
          <>
            <div className="infoLine"> Llamá al +54 261 4439300⁠</div>
            <div className="infoLine">San Martín Sur 600.</div>
          </>
        )}
      </div>
    );
  }
}
